import { Redirect, useGlobalSearchParams } from 'expo-router';

import { AuthContainer, VerifyOtp } from '@fhs/auth';

export default function VerifyOtpPage() {
  const { loginJwt } = useGlobalSearchParams<{ loginJwt?: string }>();
  if (!loginJwt) {
    return <Redirect href="/v2/signin" />;
  }
  return (
    <AuthContainer>
      <VerifyOtp />
    </AuthContainer>
  );
}
